export default Copy = {
  mounted() {
    let button = this.el;
    let { to } = this.el.dataset;

    this.el.addEventListener("click", (ev) => {
      ev.preventDefault();
      let text = document.querySelector(to).value;
      navigator.clipboard.writeText(text).then(() => {
        this.pushEvent("url-copied", {});
      });
    });
  },
};
